import _ from "lodash";

import { GenerateShippingLabelFormData } from "./OrderGenerateShippingLabel";

export const SubmitButtonValidation = (
  type,
  formData: GenerateShippingLabelFormData
) => {
  if (type === "ORDER_LIST_ACTION") {
    return false;
  } else {
    const isEmptyData = Object.values(formData).every(
      x => x === null || x === "" || x === false
    );

    if (_.isEmpty(formData) || isEmptyData) {
      return true;
    }
    // if (hasChanged) {
    //   return false;
    // } else {
    //   return true;
    // }
  }
};
